import * as React from 'react';
export const IcMap = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M2 4.91v8.71a3 3 0 001 2.28L7.81 20c.202.17.437.295.69.37V6.64L4.37 3.69A1.5 1.5 0 002 4.91zm19.12 3.21l-4-4a2.069 2.069 0 00-.58-.4V16.5l2.94 2.94A1.5 1.5 0 0022 18.38v-8.14a3 3 0 00-.88-2.12zM9.5 6.71V20.4c.277-.043.54-.15.77-.31l5.23-3.73V3.52a2.08 2.08 0 00-.83.24L9.5 6.71z'
      fill='currentColor'
    />
  </svg>
);
